/**
* @author XuZiYu
* @date 2019/7/8
* @time 17:08
*/
<template>
  <div class="wrapper-submit-order">
    <div class="user-info-model" @click="goAddress">
      <div class="none" v-if="!address.receiverCompleteAddress">+添加收货地址</div>
      <div class="show" v-else>
        <div class="icon-left">
          <img src="../../assets/public/icon_address_yellow@2x.png" alt=""/>
        </div>
        <div class="info">
          <div class="user">
            <span class="name">{{address.receiverName}}</span>
            <span class="phone">{{address.receiverMobile}}</span>
          </div>
          <div class="address">
            {{address.receiverCompleteAddress}}
          </div>
        </div>
        <div class="icon-right">
          <van-icon name="arrow" color="#999999" size="1.7333vw"/>
        </div>
      </div>
    </div>
    <div class="order-info">
      <div class="goods-model">
        <div class="goods-img">
          <img :src="info.imgUrl" alt=""/>
        </div>
        <div class="goods-info">
          <h2>{{info.name}}</h2>
          <div class="goods-price-num">
            <span><b>{{info.unitRmbPrice ? info.unitBeanPrice ? `¥${info.unitRmbPrice}+` : `¥${info.unitRmbPrice}`  :'' }}{{info.unitBeanPrice ? info.unitBeanPrice: ''}}</b>{{info.unitBeanPrice ? '斑豆' : '' }}</span>
            <span>*{{value}}</span>
          </div>
        </div>
      </div>
      <div class="num-model">
        <span>购买数量</span>
        <van-stepper v-model="value" integer button-size="6.4vw" :max="info.limitNum || 10"/>
      </div>
      <div class="model">
        <span>配送方式</span>
        <span>{{info.expressTypeName}}<b>{{info.expressPrice > 0 ? `¥ ${info.expressPrice}`: ''}}</b></span>
      </div>
      <div class="model">
        <span>支付方式</span>
        <span>{{selectOption.paymentType[info.paymentType]}}</span>
      </div>
    </div>
    <div class="footer">
      <span class="money">
        合计 <b>{{(info.unitRmbPrice + info.expressPrice > 0) ? info.unitBeanPrice ? `¥${(info.unitRmbPrice * value + info.expressPrice).toFixed(2)}+` : `¥${(info.unitRmbPrice * value + info.expressPrice).toFixed(2)}` :'' }}{{info.unitBeanPrice ? info.unitBeanPrice * value: ''}}</b>{{info.unitBeanPrice ? '斑豆' : '' }}
      </span>
      <van-button class="btn-submit" @click="submit" :loading="loading">提交订单</van-button>
    </div>
    <ctl-dialog v-model="dialogData" :loading="loading"/>
  </div>
</template>

<script>
import { Icon, Stepper, Button, Toast } from 'vant'
import dialog from '@/components/dialog/index.vue'
export default {
    name: 'submitOrder',
    components: {
        [Icon.name]: Icon,
        [Toast.name]: Toast,
        ctlDialog: dialog,
        [Button.name]: Button,
        [Stepper.name]: Stepper
    },
    data () {
        return {
            value: 1,
            dialogData: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            selectOption: {
                expressType: {
                    1: '快递',
                    2: '其他'
                },
                paymentType: {
                    1: '在线支付',
                    2: '斑豆支付',
                    3: '在线支付+斑豆支付'
                }
            },
            address: {},
            loading: false,
            info: {},
            goodsInfo: {}
        }
    },
    methods: {
        errorMessage (v) {
            this.dialogData = {
                visible: true,
                rightBtnName: '确定',
                leftBtnName: '',
                leftBtnMethod: () => {
                },
                rightBtnMethod: () => {
                    this.dialogData.visible = false
                },
                title: '提示',
                content: v
            }
        },
        // 打开app地址栏
        goAddress () {
            this.$jsBridge.callBackHandler('pushAddressMgPage')
        },
        // 添加地址
        addressCallback (v) {
            let data = JSON.parse(v)
            this.$set(this.address, 'province', data.provinceCode)
            this.$set(this.address, 'city', data.cityCode)
            this.$set(this.address, 'country', data.regionCode)
            this.$set(this.address, 'receiverAddress', data.address)
            this.$set(this.address, 'receiverMobile', data.phone)
            this.$set(this.address, 'receiverName', data.consignee)
            this.$set(this.address, 'receiverCompleteAddress', data.detailAddress)
        },
        // 获取默认地址
        getDefaultAddress () {
            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            this.$api.getDefaultAddress().then(res => {
                setTimeout(() => { Toast.clear() }, 500)
                if (res.status && res.result) {
                    let data = res.result
                    this.$set(this.address, 'province', data.province)
                    this.$set(this.address, 'city', data.city)
                    this.$set(this.address, 'country', data.country)
                    this.$set(this.address, 'receiverAddress', data.receiverAddress)
                    this.$set(this.address, 'receiverMobile', data.receiverMobile)
                    this.$set(this.address, 'receiverName', data.receiverName)
                    this.$set(this.address, 'receiverCompleteAddress', data.receiverCompleteAddress)
                }
            })
        },
        // 提交购买订单
        submit () {
            if (!this.address.receiverCompleteAddress) {
                this.errorMessage('请选择地址')
                return
            }
            let data = {
                province: this.address.province,
                city: this.address.city,
                country: this.address.country,
                receiverAddress: this.address.receiverAddress,
                receiverMobile: this.address.receiverMobile,
                receiverName: this.address.receiverName,
                receiverCompleteAddress: this.address.receiverCompleteAddress,
                expressPrice: this.info.expressPrice,
                expressType: this.info.expressType,
                listGoods: {
                    amount: this.value,
                    goodsId: this.goodsInfo.id,
                    goodsName: this.goodsInfo.name,
                    refundFlag: this.goodsInfo.refundFlag,
                    unitBeanPrice: this.info.unitBeanPrice,
                    unitRmbPrice: this.info.unitRmbPrice
                },
                orderNo: this.info.orderNo,
                orderBeanAmount: this.info.unitBeanPrice * this.value,
                orderRmbAmount: (this.info.unitRmbPrice * this.value + this.info.expressPrice).toFixed(2),
                paymentType: this.info.paymentType
            }
            let Fn = () => {
                this.loading = true
                this.$api.saveMallOrder(data).then(res => {
                    this.loading = false
                    this.dialogData.visible = false
                    if (res.code === '500') {
                        this.errorMessage(res.message)
                    } else if (res.result.returnMsg) {
                        this.dialogData = {
                            visible: true,
                            rightBtnName: '去做任务',
                            leftBtnName: '取消',
                            leftBtnMethod: () => {
                                this.dialogData.visible = false
                            },
                            rightBtnMethod: () => {
                                this.dialogData.visible = false
                                // 跳转斑豆任务
                                this.$jsBridge.callBackHandler('pushBandouCenterPage')
                            },
                            title: '提示',
                            content: res.result.returnMsg
                        }
                    } else if (this.info.paymentType === 2) {
                        this.$router.push({ name: 'payResult', query: { result: '1' } })
                    } else {
                        this.$router.replace({ name: 'pay', query: { payId: res.result.id, money: data.orderRmbAmount, type: '2' } })
                    }
                })
            }
            if (this.info.paymentType === 2) {
                this.dialogData = {
                    visible: true,
                    rightBtnName: '确定兑换',
                    leftBtnName: '取消',
                    leftBtnMethod: () => {
                        this.dialogData.visible = false
                    },
                    rightBtnMethod: () => {
                        Fn()
                    },
                    title: '提示',
                    content: `您将消费${this.info.unitBeanPrice * this.value}斑豆，确定兑换该商品吗？`
                }
            } else {
                Fn()
            }
        }
    },
    created () {
        // 暴露添加地址方法
        this.$jsBridge.registerHandler('addressCallback', this.addressCallback)

        this.$set(this, 'info', JSON.parse(JSON.stringify(this.$store.getters.exchangeGoodsInfo)))
        this.$set(this, 'goodsInfo', JSON.parse(JSON.stringify(this.$store.getters.goodsInfo)))
        this.getDefaultAddress()
    }
}
</script>
<style scoped lang="scss">
  .wrapper-submit-order{
    /deep/ {
      .van-stepper{
        overflow: hidden;
        border: 1px solid #CCCCCC;
        box-sizing: border-box;
        .van-stepper__input{
          margin: 0;
          background: #ffffff;
          font-size:14px;
          font-weight:400;
          color:rgba(51,51,51,1);
        }
        .van-stepper__minus{
          border-right: 1px solid #CCCCCC;
          background: #ffffff;
          :before{
            color: #000000;
          }
        }
        .van-stepper__plus{
          border-left: 1px solid #CCCCCC;
          background: #ffffff;
        }
      }
    }

  }
  .footer{
    border-top: 1px solid #eeeeee;
    background: #ffffff;
    height: 49px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    .money{
      text-align: center;
      flex: 1;
      font-size:17px;
      font-weight:400;
      color:rgba(51,51,51,1);
      white-space: nowrap;
      text-overflow:ellipsis;
      overflow: hidden;
      b{
        color: #FF5050;
      }
    }
    .btn-submit{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      border:none;
      width: 150px;
      background:rgba(83,203,133,1);
      font-size:18px;
      font-weight:600;
      color:rgba(255,255,255,1);
    }
  }
  .model{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 0;
    border-top: 1px solid #EEEEEE;
    box-sizing: border-box;
    span:nth-child(1){
      font-size:14px;
      font-weight:400;
      color:rgba(102,102,102,1);
    }
    span:nth-child(2){
      font-size:14px;
      font-weight:400;
      color:rgba(51,51,51,1);
      b{
        color: #FF5050;
        margin-left: 5px;
      }
    }
  }
  .num-model{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 0;
    border-top: 1px solid #EEEEEE;
    box-sizing: border-box;
    span:nth-child(1){
      font-size:14px;
      font-weight:400;
      color:rgba(102,102,102,1);
    }
  }
  .order-info{
    background: #ffffff;
    padding: 0 15px;
    .goods-model{
      display: flex;
      align-items: center;
      padding: 15px 0;
      background: #ffffff;
      .goods-img{
        width: 100px;
        height: 100px;
        overflow: hidden;
        display: flex;
        align-items: center;
        img{
          width: 100px;
        }
      }
      .goods-info{
        margin-left: 15px;
        flex: 1;
        h2{
          font-size:15px;
          font-weight:400;
          color:rgba(51,51,51,1);
        }
        .goods-price-num{
          display: flex;
          margin-top: 10px;
          align-items: center;
          justify-content: space-between;
          span{
              max-width: 100px;
              white-space: nowrap;
              text-overflow:ellipsis;
              overflow: hidden;
          }
          span:nth-child(1){
            font-size:14px;
            font-weight:600;
            color:#666666;
            b{
              color: #FF5050;
            }
          }
          span:nth-child(2){
            font-size:14px;
            font-weight:400;
            color:rgba(51,51,51,1);
          }
        }
      }
    }
  }
  .wrapper-submit-order{
    background: #FAFAFA;
    height: 100vh;
  }
  .user-info-model{
    background: #ffffff;
    margin-bottom: 10px;
    padding: 15px;
    .none{
      font-size:14px;
      font-weight:400;
      color:rgba(83,203,133,1);
      text-align: center;
    }
    .show{
      display: flex;
      align-items: center;
    }
    .icon-left{
      line-height: 1;
      font-size: 0;
      img{
        width: 24px;
      }
    }
    .info{
      margin:0 17px 0 15px;
      .user{
        display: flex;
        align-items: center;
        .name{
          font-size:18px;
          font-weight:600;
          color:rgba(51,51,51,1);
        }
        .phone{
          margin-left: 15px;
          font-size:14px;
          font-weight:400;
          color:rgba(51,51,51,1);
        }
      }
      .address{
          word-break: break-all;
        margin-top: 5px;
        font-size:14px;
        font-weight:400;
        color:rgba(51,51,51,1);
      }

    }
  }
</style>
